import { useEffect } from 'react';

function useFirstLoad(playerState, callback) {
  const { isTestReady, firstChunkQuestionsApi } = playerState;

  const listenToRenderedQuestions = (questionsApi) => {
    //triggerCallback - it is a named function to get access to the API
    //"this" returns the API context not the parent
    function triggerCallback() {
      const questionApi = this;
      const metadata = questionApi?.getMetadata();
      if (!metadata) {
        return;
      }
      callback(questionApi);

      questions?.forEach((q) => {
        q?.off('rendered', triggerCallback);
      });
    }

    const questions = Object.values(questionsApi);
    if (questions.length > 0) {
      questions.every((questionApi) => {
        if (questionApi?.isRendered()) {
          triggerCallback.call(questionApi);
          return false;
        }

        questionApi?.on('rendered', triggerCallback);
        return true;
      });
    }
  };

  useEffect(() => {
    if (isTestReady) {
      listenToRenderedQuestions(firstChunkQuestionsApi);
    }
  }, [isTestReady]);

  return null;
}

export default useFirstLoad;
